import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import _ from "lodash";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import styles from "./vehicleExportForm.module.scss";
import CheckboxGroup from "../../../components/checkBoxGroupComponent/CheckboxGroup";
import Button from "../../../components/buttons/Buttons";
import i18next from "i18next";
import FormikControl from "../../../components/formComponents/FormikControl";
import {
  dateFormats,
  dateInputValidation,
  downloadCsv,
  generalValidationMessage,
} from "../../../config/appConfig";
import {
  exportVehilce,
  getCertificatesList,
  getDealerDropDownList,
} from "../../../services/APIService";
import { useApiErrorModalContext } from "../../../errorHandling/ApiErrorModalContext";

const VehicleExportForm = () => {
  let defaultInitialValue = {
    fromeDate: "",
    toDate: "",
    dealerList: [],
  };
  const { setApiErrorModalState } = useApiErrorModalContext();
  const [dealerDropdownList, setDealerDropdownList] = useState([]);
  const [certificateList, setCertificateList] = useState([]);
  const initalValue = defaultInitialValue;
  const [assignCertificatesOptions, setAssignCertificatesOptions] = useState(
    []
  );
  const [isDealerListLoading, setIsDealerListLoading] = useState(false);
  const translatedGeneralValidationMessage = `${i18next.t(
    generalValidationMessage
  )}`;
  const validationSchema = Yup.object().shape({
    fromeDate: Yup.string()
      .typeError(translatedGeneralValidationMessage)
      .required(translatedGeneralValidationMessage),
    toDate: Yup.string()
      .typeError(translatedGeneralValidationMessage)
      .required(translatedGeneralValidationMessage),
  });

  const getDealersList = (params = {}) => {
    getDealerDropDownList(params)
      .then((response) => {
        if (
          !_.isEmpty(_.get(response, "errorMessage", "")) ||
          _.get(response, "success", true) === false
        ) {
          _.set(response, "status", 200);
          setIsDealerListLoading(false);

          setApiErrorModalState({ error: response });
        } else {
          setIsDealerListLoading(false);
          setDealerDropdownList(response);
        }
      })
      .catch((err) => {
        setIsDealerListLoading(false);

        setApiErrorModalState({ error: err });
      });
  };

  useEffect(() => {
    getCertificatesList({})
      .then((response) => {
        if (
          !_.isEmpty(_.get(response, "errorMessage", "")) ||
          _.get(response, "success", true) === false
        ) {
          _.set(response, "status", 200);

          setApiErrorModalState({ error: response });
        } else {
          setCertificateList(response);
          let certificateNames = response.map((certificate) => {
            return certificate.key;
          });
          setAssignCertificatesOptions(["All", ...certificateNames]);
        }
      })
      .catch((err) => {
        setApiErrorModalState({ error: err });
      });
    //get dealer
    getDealersList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const stauts = ["All", "Active", "Inactive"];

  const onDealerInputChange = (searchTerm) => {
    setIsDealerListLoading(true);

    if (!isDealerListLoading || searchTerm.length === 0) {
      getDealersList({ searchTerm: searchTerm });
    }
  };

  const handleCheckBoxChange = (
    event,
    optionList,
    setFieldValue,
    fieldName,
    valueList
  ) => {
    let value = {};

    if (event.target?.name === "All") {
      if (event.target?.checked === true) {
        valueList.map((field) => {
          value = { ...value, ...{ [field]: true } };
          return value;
        });
      } else {
        valueList.map((value) => {
          value = { ...value, ...{ [value]: false } };
          return value;
        });
      }
    } else {
      value = {
        ...optionList,
        [event.target?.name]: event.target?.checked,
      };
      let allChecked = Object.keys(value).filter(
        (field) => value[field] && field !== "All"
      );
      if (allChecked.length !== valueList.length - 1) {
        value = { ...value, ...{ All: false } };
      } else {
        value = { ...value, ...{ All: true } };
      }
    }

    setFieldValue(fieldName, value);
  };

  const getStatusValue = (status) => {
    if (_.includes(status, "All")) {
      return 100;
    } else {
      if (_.includes(status, "Active")) {
        return 1;
      } else if (_.includes(status, "Inactive")) {
        return 0;
      }
      return 100;
    }
  };

  const handleDownload = (values) => {
    if (_.isEmpty(values.fromeDate) || _.isEmpty(values.toDate)) {
      return;
    }
    let dealerIds = _.get(values, "dealerList", [])?.map(
      (dealer) => dealer?.value
    );
    let certificates = Object.keys(
      _.pickBy(_.get(values, "AssignCertificatesOptions", {}))
    );
    let vehicleStatus = getStatusValue(
      Object.keys(_.pickBy(_.get(values, "stauts", {})))
    );

    let certificateIds;
    if (_.includes(certificates, "All")) {
      certificateIds = certificateList.map((option) => option.id);
    } else {
      certificateIds = certificates.map((certificate) => {
        let selectedCertificate = certificateList.filter(
          (option) => option.key === certificate
        )[0];

        return selectedCertificate.id;
      });
    }

    exportVehilce({
      ...values,
      ...{
        certificateIds: _.isEmpty(certificateIds) ? [0] : certificateIds,
        vehicle_Status: vehicleStatus,
        dealerIds: _.isEmpty(dealerIds) ? [0] : dealerIds,
      },
    })
      .then((response) => {
        if (
          !_.isEmpty(_.get(response, "errorMessage", "")) ||
          _.get(response, "success", true) === false
        ) {
          _.set(response, "status", 200);

          setApiErrorModalState({ error: response });
        } else {
          downloadCsv(response.fileData, response.fileName);
        }
      })
      .catch((err) => {
        setApiErrorModalState({ error: err });
      });
  };

  const hasErrorCheck = (touched, errors, name) => {
    return !!(touched[name] && errors[name]);
  };

  return (
    <Box
      className={styles.vehicleExportFormWrapper}
      data-testid="VehicleExportForm"
    >
      <Formik
        initialValues={initalValue}
        validationSchema={validationSchema}
        enableReinitialize={true}
        onSubmit={(values) => {
          handleDownload(values);
        }}
      >
        {({
          errors,
          touched,
          handleSubmit,
          values,
          setFieldValue,
          setFieldTouched,
        }) => (
          <Form onSubmit={handleSubmit}>
            <Box className={`formWrapper ${styles.dealerExportFormWrapper}`}>
              <Box className="textboxDoubleWraper">
                <FormikControl
                  variant="filled"
                  control="apiFilterMultiSelect"
                  label="Vehicle by dealer"
                  options={isDealerListLoading ? [] : dealerDropdownList}
                  hiddenLabel
                  id="multiSelectDropdown"
                  name="dealerList"
                  size="small"
                  hasSelectAll={false}
                  disableCloseOnSelect={true}
                  loading={isDealerListLoading}
                  noOptionsText={
                    <Box>
                      <Box>{i18next.t("No results found")}</Box>
                    </Box>
                  }
                  onInputChange={(event, newInputValue) => {
                    onDealerInputChange(newInputValue);
                  }}
                  isSelect={true}
                  disabled={false}
                  placeholder={i18next.t("Select dealer")}
                  className="input-grp__box select"
                  freeSolo={false}
                  hasSubText={true}
                  subTextField={{
                    title: "key",
                    id: "value",
                    subText: ["street", "houseNo", "city", "postcode"],
                  }}
                  onChange={(e, value) => {
                    setFieldTouched("dealerList", false);
                    setFieldValue("dealerList", value);
                  }}
                  value={values.dealerList}
                  hasError={hasErrorCheck(touched, errors, "dealerList")}
                  error={hasErrorCheck(touched, errors, "dealerList")}
                  errorMessage={errors?.dealerList}
                />
              </Box>
              <Box className={styles.exportCheckBoxGroup}>
                <Box className="input-grp__label">
                  {i18next.t("Trademarks")}
                </Box>
                <CheckboxGroup
                  checkBoxList={assignCertificatesOptions}
                  name="AssignCertificatesOptions"
                  handleChange={(e) =>
                    handleCheckBoxChange(
                      e,
                      values.AssignCertificatesOptions,
                      setFieldValue,
                      "AssignCertificatesOptions",
                      assignCertificatesOptions
                    )
                  }
                  checkBoxState={values.AssignCertificatesOptions}
                />
              </Box>
              <Box className={styles.exportCheckBoxGroup}>
                <Box className="input-grp__label">
                  {i18next.t("Vehicle status")}
                </Box>
                <CheckboxGroup
                  checkBoxList={stauts}
                  name="stauts"
                  handleChange={(e) =>
                    handleCheckBoxChange(
                      e,
                      values.stauts,
                      setFieldValue,
                      "stauts",
                      stauts
                    )
                  }
                  checkBoxState={values.stauts}
                />
              </Box>

              <Box className="textboxDoubleWraper">
                <FormikControl
                  variant="filled"
                  control="datepicker"
                  hiddenLabel
                  label={i18next.t("From date")}
                  id="fromeDate"
                  name="fromeDate"
                  value={values.fromeDate}
                  placeholderText={i18next.t("Select From date")}
                  format={"DD-MM-YYYY"}
                  onChange={(date, { customInput, isTyping }) => {
                    let input = document.getElementById("fromeDate-datepicker");

                    setFieldTouched("fromeDate", false);

                    if (!isTyping) {
                      if (_.isEmpty(date?.format())) {
                        return setFieldValue("fromeDate", "");
                      }

                      return setFieldValue("fromeDate", date.format()); // user selects the date from the calendar and no needs for validation.
                    }
                    if (!dateInputValidation(input, date)) {
                      return false;
                    }

                    setFieldValue("fromeDate", date?.format());
                  }}
                  dateFormat={dateFormats.datePickerFormat}
                  error={touched?.fromeDate && errors?.fromeDate}
                  errorMessage={errors?.fromeDate}
                />
                <FormikControl
                  variant="filled"
                  control="datepicker"
                  hiddenLabel
                  label={i18next.t("To date (inclusive)")}
                  id="toDate"
                  name="toDate"
                  value={values.toDate}
                  placeholderText={i18next.t("Select To date")}
                  format={"DD-MM-YYYY"}
                  onChange={(date, { customInput, isTyping }) => {
                    let input = document.getElementById("toDate-datepicker");

                    setFieldTouched("toDate", false);

                    if (!isTyping) {
                      if (_.isEmpty(date?.format())) {
                        return setFieldValue("toDate", "");
                      }

                      return setFieldValue("toDate", date.format()); // user selects the date from the calendar and no needs for validation.
                    }

                    if (!dateInputValidation(input, date)) {
                      return false;
                    }

                    setFieldValue("toDate", date?.format());
                  }}
                  dateFormat={dateFormats.datePickerFormat}
                  error={touched?.toDate && errors?.toDate}
                  errorMessage={errors?.toDate}
                />
              </Box>
              <Box className={styles.buttonSectionWrapper}>
                <Box className={styles.buttonWrapper}>
                  <Button
                    title="Download data"
                    iconStyle={""}
                    buttonType="muibtn-primary"
                    withIcon={false}
                    attriType={"submit"}
                  />
                </Box>
              </Box>
            </Box>
          </Form>
        )}
      </Formik>
    </Box>
  );
};

export default VehicleExportForm;
